export const EXTERNAL_URLS = {
  ARELLO: {
    PROGRAMS: {
      DADB: "https://www.arello.org/programs/disciplinary-action-database/",
      LICENSE_VERIFICATION: "https://www.arello.com",
    },
    
    ABOUT: {
      CONTACT: "https://www.arello.org/about/contact/",
    },
  },
} as const;

export type ExternalUrlPath = 
  | `ARELLO.PROGRAMS.${keyof typeof EXTERNAL_URLS.ARELLO.PROGRAMS}`
  | `ARELLO.ABOUT.${keyof typeof EXTERNAL_URLS.ARELLO.ABOUT}`;

